module.exports = __webpack_public_path__ + "static/media/seo.1b554130.svg";